export class ReservationServiceTypeDetailsModel {
    constructor(data = {}, services = []) {
        this.ServiceId = data?.ServiceId ?? null;
        this.ServiceCode = data?.ServiceCode ?? null;
        this.ServiceName = data?.ServiceName ?? null;
        this.StarRating = data?.StarRating ?? 0;
        this.ContractCode = data?.ContractCode ?? null;
        this.ContractId = data?.ContractId ?? null;
        this.LocationId  = data?.LocationId  ?? null;
        this.ClientCurrency = data?.ClientCurrency ?? null;
        this.Description = data?.Description ?? null;
        this.CancellationPolicy = {
            CheckIn: data?.CancellationPolicy?.CheckIn ?? null,
            Description: data?.CancellationPolicy?.Description ?? null,
            Details: Array.isArray(data?.CancellationPolicy?.Details)
                ? [...data.CancellationPolicy.Details]
                : []
        };
        this.ServiceUnitRequestResults = data?.ServiceUnitRequestResults?.map((serviceRequest) => {
            const serviceUnits = serviceRequest.Units.map(unit => ({
                ...unit,
                TotalCost: 0,
                IsUnitSelected: false
            }));

            return {
                serviceUnitRequestId: serviceRequest.ServiceUnitRequestId,
                serviceUnits,
            };
        }) ?? [];
        this.SelectedService = services.find(h => h.ServiceId === this.ServiceId) ?? null;
    }
}